module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0141.jpg?v=6c18abb4";